
type Props = {
    children: React.ReactNode
}
export default function Message(props: Props) {

    const { children } = props

    return (
        <div className="relative flex-center bg-white max-w-ful py-3 px-3 rounded-[1rem] text-main-800 short:text-[0.875rem] font-medium shadow-sm">
            {children}
            {/* <div className="absolute -bottom-3 right-[10%] border-l-[0.5rem] border-l-transparent border-t-[1.5rem] border-white border-r-[0.5rem] border-r-transparent rotate-[30deg]"></div> */}
            <div className="absolute -bottom-[0.8rem] border-l-[0.75rem] border-l-transparent border-t-[1.5rem] border-t-white border-r-[0.75rem] border-r-transparent"></div>
        </div>
    )
}